<template>
  <div class="dn-tag">
    <dn-collection
      class="dn-tag-collection"
      :cid="tags"
      :provider="provider"
      :options="{ tags,...options }"
      mood="append"
    >
      <template #default="{collection}">
        <div
          v-if="shouldShowAd(topBanner) && !topBanner.aboveHeader"
          class="top-ad-placeholder"
        >
          <dn-ad
            :ad="topBanner"
            class="full top-ad-below-header"
            data-zone="top-ad"
          />
        </div>
        <section
          v-if="collection && collection.length > 0"
          class="dn-collection-top"
        >
          <dn-headline
            class="header"
            :text="headline"
            tag="h1"
          />
          <template
            v-for="(group, index) in groupedCollectionByLayout(collection, 'abb', 'bbb')"
            :key="index"
          >
            <template v-if="(ad = getAdForIndex(tagAdConfig?.inline || [], index)) && shouldShowAd(ad)">
              <dn-ad :ad="ad" />
            </template>
            <dn-set
              :layout="group.layout"
              :items="group.items.map((item) => ({id: item.id, type: item.type, prefetch: true, hide_lead: true}))"
            />
          </template>
        </section>
        <template
          v-else-if="!loading"
        >
          {{ emptyCollection() }}
        </template>
      </template>
    </dn-collection>
    <dn-collection-load-more
      :cid="tags"
      :size="options.hits"
      :total="total"
    />
  </div>
</template>
<script lang="ts" setup>
const nuxtApp = useNuxtApp();
const route = useRoute();
const loading = ref(false);
const tags = typeof route.params.tag === 'string'
  ? route.params.tag as string
  : route.params.tag && route.params.tag.length > 0
    ? route.params.tag[0] as string
    : '';
const {
  tag: {
    provider,
    options
  } = {},
  showEditionContent
} = useRuntimeConfig().public;

const { tag: tagAdConfig } = getAdConfig();
const topBanner = tagAdConfig?.static?.topBanner;
provide('loading', loading);
provide('teaser_provider', 'articleTeaser');
provide('teaser_asset_default_ratio', '3x2');
provide('embed_edition_content', showEditionContent !== false);
const headline = computed(() => {
  return tags.replace(/_/g, ' ').toUpperCase();
});
const total = ref(0);

let listenerCleanup: () => void | null = null;
listenerCleanup = useBusListener({
  [`DnCollection__collection__${tags}`]: (data) => {
    total.value = data.total;
  }
});

useHead({
  title: headline
});

const emptyCollection = () => {
  throw createError({
    statusCode: 404,
    message: 'No articles found for this tag'
  });
};
onUnmounted(() => {
  if (listenerCleanup) {
    listenerCleanup();
  }
});

nuxtApp.callHook('cpp:data:loaded', { type: 'tagpage', name: tags, title: headline.value });
</script>

<style lang="scss">
.dn-tag {
  display: grid;
  grid-template: auto auto / repeat(1, 1fr);
  gap: var(--row-gap);
  inline-size: min(var(--grid-width), 100vw - var(--site-padding) * 2);
  padding-bottom: calc(var(--row-gap) * 2);
  padding-top: var(--row-gap);
  margin: 0 auto;

  .dn-collection {
    --dn-grid_column-gap: var(--row-gap);
    --dn-grid_row-gap: var(--row-gap);
    --dn-edition-collection_gap: var(--row-gap);
    --dn-collection_gap: var(--row-gap);
    --dn-collection-content-width: var(--tag-topic-category-top-content-width);
    --dn-collection-top_content-width: var(--tag-topic-category-top-content-width);
    --dn-collection--header_font-family: var(--typography-editorial-subhead-min-font-family);
    --dn-collection--header_font-weight: var(--typography-editorial-subhead-min-font-weight);
    --dn-collection--header_font-size: var(--typography-editorial-subhead-min-font-size);
    --dn-collection--header_line-height: var(--typography-editorial-subhead-min-line-height);
    --dn-collection--header_border-bottom-width: 1px;
    --dn-collection--header_border-bottom-color: var(--color-page-divider);
    --dn-collection--header_spacing: 0 0 var(--ui-gap);

    @media only screen and (width >= 1300px) {
      --dn-collection_grid-template: var(--grid-template-common);
      --dn-collection-top_grid-area: var(--center_grid-area);
    }
  }
}
</style>
